<template>
  <div class="pa-10" >
    <title-page icon="mdi-file-chart-outline">
      {{ $tc('reports.exports', 2) }}
    </title-page>

    <v-breadcrumbs
        :items="[
            {text: $t('reports.reports'), to: {name: 'reports'}, exact: true},
            {text:  $tc('reports.exports', 2)},
        ]"
        divider=">"
    ></v-breadcrumbs>




    <v-row class="mt-6">
      <v-col cols="4" v-for="(item, i) in exports" :key="'export-' + i">
        <v-card class="fill-height">
          <v-card-title>
                {{ item.label }}
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col class="text-center">
                <v-icon size="80">{{ item.icon }}</v-icon>
              </v-col>
            </v-row>
            <template v-if="item.hasTele2Filters">
              <v-row dense class="mt-2">
                <v-col cols="6" offset="1">
                  <v-text-field
                      v-model.number="tele2LookbackDays"
                      :label="$t('reports.lookback-days')"
                      type="number"
                      min="1"
                      dense outlined hide-details
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                      v-model="tele2EventType"
                      :label="$t('reports.event-type')"
                      :items="tele2EventTypeOptions"
                      dense outlined hide-details clearable
                  />
                </v-col>
              </v-row>
            </template>
            <v-row v-if="item.hasLookbackDays" dense class="mt-2">
              <v-col cols="8" offset="2">
                <v-text-field
                    v-model.number="lookbackDays"
                    :label="$t('reports.lookback-days')"
                    type="number"
                    min="1"
                    dense
                    outlined
                    hide-details
                />
              </v-col>
            </v-row>
            <template v-if="item.hasAuthorizationFilters">
              <v-row dense class="mt-2">
                <v-col cols="12">
                  <date-picker
                      v-model="authDateRange"
                      :label="$t('period')"
                      range
                      clearable
                      dense
                      hide-details
                  />
                </v-col>
              </v-row>
              <v-row dense class="mt-2">
                <v-col cols="12">
                  <v-select
                      v-model="authNetworks"
                      :label="$tc('network', 2)"
                      :items="networkOptions"
                      multiple
                      small-chips
                      deletable-chips
                      dense outlined hide-details clearable
                  />
                </v-col>
              </v-row>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="justify-lg-space-between d-flex">
                <v-btn v-for="link in item.links" :key="link.label" text small  @click="download(item.type, link.args)" target="_blank" exact>{{ link.label }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn small text @click="download(item.type, getExportArgs(item))" target="_blank" exact>
                  {{ item.btnLabel ? item.btnLabel : $t('download') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>



  </div>
</template>

<script>
import FinancialRepository from "@repository/FinancialRepository";
import PieGraph from "@pages/Report/graph/PieGraph.vue";
import dayjs from "dayjs";
import ReportRepository from "../../../repository/ReportRepository";
import DatePicker from "@blocks/DatePicker";

export default {
  components: {
    DatePicker,
  },

  data() {
    return {
      lookbackDays: 30,
      tele2LookbackDays: 1,
      tele2EventType: null,
      authDateRange: [],
      authNetworks: [],
    }
  },

  mounted() {

  },

  watch: {

  },

  computed: {
    exports() {
      const exports = [
        { label: this.$t('charging-point.charging-points'), btnLabel: "Réseau ZEborne", type: 'cp', icon: 'ico-menu-charging-point', links: [{label: "Réseau Gireve", args: {network: 'gireve'}}, {label: "Réseau Hubject", args: {network: 'hubject'}} ]},
        { label: this.$tc('charging-point.evse.evse', 2), btnLabel: "Réseau ZEborne", type: 'evses', icon: 'ico-menu-charging-point', links: [{label: "Réseau Gireve", args: {network: 'gireve'}}, {label: "Réseau Hubject", args: {network: 'hubject'}} ]},
        { label: this.$tc('customer.customer', 2), type: 'customers', icon: 'ico-carplug'},
        { label: this.$tc('user.user', 2), type: 'users', icon: 'ico-users' },
        { label: this.$tc('organization.organizations', 2), type: 'organizations', icon: 'ico-organization-menu' },
        { label: this.$tc('subscription.licence', 2), type: 'licences', icon: 'ico-licence' },
        { label: this.$tc('status', 2), type: 'evseStatues', icon: 'ico-menu-charging-point' },
        { label: this.$tc('tele2', 2), type: 'tele2Events', icon: 'ico-phone', hasTele2Filters: true },
        { label: this.$t('reports.sim-operators'), type: 'simOperators', icon: 'mdi-sim', hasLookbackDays: true },
        { label: this.$t('reports.active-offline-charging-points'), type: 'activeOfflineChargingPoints', icon: 'mdi-lan-disconnect' },
      ];

      if(this.isMainDeveloper) {
        exports.push({ label: 'authorizations without cdr', type: 'authorizationWithoutCdr', icon: 'ico-invoice', hasAuthorizationFilters: true })
      }
      exports.push({ label: 'customers-with-permissions-config', type: 'customersWithPermissionsConfig', icon: 'ico-licence' })

      return exports;
    },

    tele2EventTypeOptions() {
      return [
        { text: 'SESSION_START', value: 'SESSION_START' },
        { text: 'SESSION_STOP', value: 'SESSION_STOP' },
      ]
    },

    networkOptions() {
      return [
        { text: 'ZEborne', value: 'internal' },
        { text: 'Gireve', value: 'gireve' },
        { text: 'Hubject', value: 'hubject' },
      ]
    },
  },

  methods: {
    getExportArgs(item) {
      if (item.hasLookbackDays) return { lookbackDays: this.lookbackDays }
      if (item.hasTele2Filters) {
        const args = { lookbackDays: this.tele2LookbackDays }
        if (this.tele2EventType) args.eventType = this.tele2EventType
        return args
      }
      if (item.hasAuthorizationFilters) {
        const args = {}
        if (this.authDateRange && this.authDateRange.length === 2) {
          // Range picker may return dates in any order — sort ascending.
          const sorted = [...this.authDateRange].sort()
          args.dateFrom = sorted[0]
          // Backend filters createdAt <= dateTo at 00:00, so push dateTo to next day
          // to include the whole selected end day.
          args.dateTo = dayjs(sorted[1]).add(1, 'day').format('YYYY-MM-DD')
        }
        if (this.authNetworks && this.authNetworks.length) args.network = this.authNetworks
        return args
      }
      return item.args
    },

    download(type, args) {
      if(['cp', 'evses', 'customers', 'licences', 'organizations', 'users', 'authorizationWithoutCdr', 'customersWithPermissionsConfig', 'evseStatues', 'tele2Events', 'simOperators', 'activeOfflineChargingPoints'].includes(type)) {
        this.showLoading(true)
        ReportRepository[type + 'Export'](args).then(() => {
          this.showLoading(false)
        }).catch(err => {
          this.showLoading(false)
          this.notifyError(err)
        })
      }
    }
  }
}
</script>

<style lang="scss">

</style>